import React, { Component } from 'react';
import PT from 'prop-types';
import { Input, Grid, Button } from 'semantic-ui-react';
import classes from './mobileFooter.css';
import api from '../../../../lib/api';

const EMAIL_REGEX = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

class MobileFooterTextBlurb extends Component {
  static propTypes = {
    footerSubmit: PT.func,
  }
  static defaultProps = {
    footerSubmit: () => true,
  }
  constructor(props) {
    super(props);
    this.state = {
      mail: '',
      disabled: true,
    };
  }

  footerSubmit = (ev) => {
    ev.preventDefault();
    if( this.state.disabled )
      return;
    const { subscribe: { subscribeViaFooter } } = api({});
    subscribeViaFooter({email: this.state.mail}).then(({msg: res}) => {
      this.setState({ mail: '', disabled: true });
      alert(res);
    }).catch(err => {
      alert(err);
    });
  };

  handleOnChange = (ev, { name, value }) => {
    this.setState({ mail: value });
    if (!EMAIL_REGEX.test(value))
      this.setState({ disabled: true });
    else
      this.setState({ disabled: false });
  }

  render() {
    const { disabled } = this.state;
    return (
      <Grid.Column width={16}>
        <div className={classes.footerLeftLabel}>
          <span className={classes.footerLeftLabelText}>Newsletter</span>
        </div>
        <form onSubmit={this.footerSubmit}>
          <Input
            transparent
            placeholder="Enter your email address"
            onChange={this.handleOnChange}
            className={classes.enterEmailInput}
            value={this.state.mail}
          >
            <input />
          </Input>
          <Button
            className={classes.signUpButton}
            onClick={this.footerSubmit}
            disabled={disabled}
          >
            SIGN UP
          </Button>
        </form>
        <p className={classes.footerBlurbText}>
          Sign up for our free newsletter and get great tips and updates.
        </p>
      </Grid.Column>);
  }
}
export default MobileFooterTextBlurb;



// WEBPACK FOOTER //
// ./src/app/components/Footer/MobileFooter/NewsletterSignUp.js